import { actions } from "@app/utils";
import { createApiClient } from "@app/utils/apiClient";

export const linkCheckerClient = createApiClient(
  actions["exd-storyteller-ai/linkChecker"],
);

export const checkLink = async (url, options = {}) => {
  const response = await linkCheckerClient.post(
    "",
    {
      url,
    },
    options,
  );

  if (!response.ok) {
    throw new Error("Failed to check link", { cause: response });
  }

  return response.data;
};
